export enum Destination {
	ABROAD = 'ABROAD',
	BELGIUM = 'BELGIUM',
}

export const DESTINATIONS = [Destination.BELGIUM, Destination.ABROAD];
